// libs
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'

// interfaces / constants
import PostCreate, {
  IMapRouteToProps,
  IOwnProps,
  IPostCreateStoreState
} from 'src/components/post/create/create'
import { Id } from 'src/interfaces'
import { IVerifiedUserProfile } from 'src/interfaces/user'
import { IRootState } from 'src/reducers/interface'
import { CREATE_POST } from 'src/utils/reporting/events_tracking/events_tracking'

// components
import withLoadingSpinner from 'src/high_order_components/with_loading_spinner'

// helpers
import { withRouterProps } from 'src/high_order_components/connect_route_props'
import { withContentItemMutations } from 'src/high_order_components/with_content_item_mutations'
import { withTrackerProps } from 'src/high_order_components/with_tracker_props'

const mapStateToProps = (state: IRootState): IPostCreateStoreState => {
  const selectedProfileId = state.user.selectedProfileId
  // The post create feature cannot have an intermediate profile, or not logged In one.
  const profile = state.user.profiles[selectedProfileId] as IVerifiedUserProfile

  return {
    loggedInProfileAddress: profile.address,
    profileType: profile.type
  }
}

const mapRouteToProps = ({ match, history, location }: RouteComponentProps<{ id: Id }>): IMapRouteToProps => (
  {
    history,
    matchUrl: match.url,
    path: location.pathname,
    search: location.search
  })

export default withRouterProps<IMapRouteToProps, IOwnProps>(mapRouteToProps)(
  connect<
  IPostCreateStoreState,
  never,
  IOwnProps & IMapRouteToProps
  >(
    mapStateToProps
  )(
    withTrackerProps<
    typeof CREATE_POST,
    IOwnProps &
    IMapRouteToProps &
    IPostCreateStoreState
    >(CREATE_POST)(
      withLoadingSpinner(
        withContentItemMutations(
          PostCreate
        ))
    )
  )
)
